import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { HeadersEnum, ParamsKeys, ParamsValues, RestURLsEnum } from '../model/http-request-enums';
import { CatalogueItem } from '../model/catalogue-category/catalogue-item.model';
import { AnalyticalTest } from '../model/analytical-test/analytical-test.model';
import { IProduct } from '../model/contract/product.contract';
import { AppState } from '../store/app.reducers';
import { Store } from '@ngrx/store';
import { AddCatalogueItems } from '../store/sampling-supplies/sampling-supplies.actions';
import { BehaviorSubject } from 'rxjs';
import { remove } from '../utils/util-functions';
import { getItemFromRawItem } from '../model/cart.model';

@Injectable()
export class CatalogueService {
    // currentCatalogueItem: CatalogueItem | AnalyticalTest;
    currentCatalogueItem: IProduct;
    SAMPLING_TYPE = 'sampling-item';
    CONTAINER_TYPE = 'container-item';

    loadingIds = new BehaviorSubject({});

    header = new HttpHeaders().set(ParamsKeys.ACCEPT,
        [HeadersEnum.ACCEPT_CATEGORY, HeadersEnum.ACCEPT_ERROR].join(','));

    catalogueItemHeader = new HttpHeaders().set(ParamsKeys.ACCEPT, [
        HeadersEnum.ACCEPT_CATALOGUE_ITEM,
        HeadersEnum.ACCEPT_ERROR,
    ].join(','));

    catalogueItemURL = environment.csBaseURL + RestURLsEnum.CATALOGUE_ITEM;
    catalogueItemParams: HttpParams = new HttpParams()
        .set(ParamsKeys.INCLUDE, [ParamsValues.PRICES, ParamsValues.EXTENDED_INFO].join(','))
        .set(ParamsKeys.EXCLUDE, ParamsValues.NO_PRICE);

    constructor(private httpClient: HttpClient,
        private router: Router,
        private store: Store<AppState>) {
    }

    toProductPage(catalogueItem: CatalogueItem | AnalyticalTest) {
        this.currentCatalogueItem = catalogueItem;
        if (this.isSampling(this.currentCatalogueItem)) {
            this.router.navigate(['sampling-supplies/', catalogueItem.id]);
        } else {
            this.router.navigate(['lab-tests/analytical-test/', catalogueItem.id]);
        }
    }

    getCurrentProduct(catalogueItemId: number) {

        if (this.currentCatalogueItem === undefined
      || (this.currentCatalogueItem.id !== catalogueItemId)
      || !this.isSampling(this.currentCatalogueItem)) {

            let ids = this.loadingIds.getValue();
            ids = { ...ids, [catalogueItemId]: catalogueItemId };
            this.loadingIds.next(ids);

            return this.httpClient.get(this.catalogueItemURL + catalogueItemId,
                {
                    params: this.catalogueItemParams,
                    headers: this.catalogueItemHeader
                })
                .toPromise()
                .then(
                    (resBody) => {

                        const obj = this.loadingIds.getValue();
                        this.loadingIds.next(remove(obj, catalogueItemId));

                        this.currentCatalogueItem = getItemFromRawItem(resBody);

                        if (this.isSampling(this.currentCatalogueItem)) {
                            this.store.dispatch(new AddCatalogueItems([<CatalogueItem> this.currentCatalogueItem]));
                        }

                        return this.currentCatalogueItem;
                    }
                );
        } else {
            return this.currentCatalogueItem;
        }
    }

    isSampling(item) {
        return item instanceof CatalogueItem;
    }

    getLoadingIds() {
        return this.loadingIds;
    }

}

